import { IHubEventBasicFormState } from './contracts'

export const UPDATE_EVENT = 'CHANGE_HUB_EVENT_BASIC_FORM_STEP_CONFIG'
export const FULL_RESET_EVENT = 'FULL_RESET_EVENT'

const changeEventConfigSection = (configSection: IHubEventBasicFormState): any => {
  return {
    type: UPDATE_EVENT,
    payload: configSection
  }
}

const fullResetEvent = (configSection?: IHubEventBasicFormState): any => {
  return {
    type: FULL_RESET_EVENT,
    payload: configSection
  }
}

export { fullResetEvent, changeEventConfigSection }
